import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Jiaohuan = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb48c__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#bb48c__a)">
            <path
              fillRule="evenodd"
              d="M42.707 13.879 35.8 6.97c-.781-.78-1.985-.786-2.766-.005l-.023.023a2.023 2.023 0 0 0-.003 2.848L38.172 15H7.015C5.911 15 5 15.91 5 17.015 5 18.09 5.857 19 6.962 19h33.624c2.673 0 4.011-3.231 2.121-5.121ZM5.293 34.12l6.907 6.91c.781.78 1.985.786 2.766.005l.068-.068c.781-.781.739-2.022-.042-2.803L9.828 33h31.157C42.089 33 43 32.09 43 30.985v-.033C43 29.847 42.143 29 41.038 29H7.414c-2.672 0-4.011 3.231-2.121 5.121Z"
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
